import React from 'react';
import { Quote } from 'lucide-react';
import { TESTIMONIALS } from '../data/mock';

const Testimonials = () => {
  return (
    <section className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <p className="text-[#1AB6FF] font-semibold uppercase tracking-[0.2em] text-xs mb-3">Testimonials</p>
          <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl leading-tight">
            Loved By Operators <span className="gradient-text">Across India.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t) => (
            <div key={t.name} className="card-tech rounded-2xl p-7 flex flex-col">
              <Quote size={28} className="text-[#1AB6FF]" />
              <p className="mt-5 text-white/80 leading-relaxed flex-1">“{t.quote}”</p>
              <div className="mt-6 pt-5 border-t border-white/5">
                <p className="font-display font-semibold text-white">— {t.name}</p>
                <p className="text-sm text-white/55 mt-0.5">{t.role} · {t.city}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
